import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { Outlet } from "react-router-dom";

const DashboardLayout = () => {
	return (
		<div className='flex h-screen overflow-hidden'>
			{/* Sidebar */}
			<div className='w-64 hidden md:block bg-white border-r border-gray-200'>
				<Sidebar />
			</div>

			{/* Main layout wrapper */}
			<div className='flex-1 flex flex-col overflow-hidden'>
				{/* Sticky Header */}
				<div className='sticky top-0 z-10 bg-white shadow'>
					<Header />
				</div>

				{/* Scrollable main content */}
				<div className='flex-1 overflow-auto'>
					<main className='p-6 min-w-[1000px]'>
						<Outlet />
					</main>
				</div>
			</div>
		</div>
	);
};

export default DashboardLayout;
